import SvgIcon from '@mui/material/SvgIcon';

import ProbeIcon from './probe-icon-24px.svg?react';

export function ProbeIconWrapper() {
	return <SvgIcon component={ProbeIcon} />;
}
